import { ReactNode } from 'react';
import { Navbar } from '../../layout/Navbar';
import { Footer } from '../../layout/Footer';
import styles from './LegalPageLayout.module.css';

interface LegalPageLayoutProps {
  title: string;
  meta: string;
  children: ReactNode;
}

export const LegalPageLayout = ({ title, meta, children }: LegalPageLayoutProps) => {
  return (
    <>
      <Navbar />
      <main className={styles.main}>
        <div className={styles.pageHeader}>
          <h1>{title}</h1>
          <p className={styles.meta}>{meta}</p>
        </div>
        <div className={styles.content}>
          {children}
        </div>
      </main>
      <Footer />
    </>
  );
};
